export const appConfig = {
  //   apiBaseUrl: process.env.REACT_APP_API_URL,
  // apiBaseUrl_Task: "http://10.131.162.57:8080/IFMS/Task",
  // apiBaseUrl_Login: "http://10.131.162.57:8080/IFMS/Login",
  // apiBaseUrl_Report: "http://10.131.162.57:8080/IFMS/Report",
  // apiBaseUrl_template: "http://10.131.162.57:8080/IFMS/template"

  apiBaseUrl_Task: "https://ifms.ril.com/IFMS/Task",
  apiBaseUrl_Login: "https://ifms.ril.com/IFMS/Login",
  apiBaseUrl_Report: "https://ifms.ril.com/IFMS/Report",
  apiBaseUrl_template: "https://ifms.ril.com/IFMS/template"
};
